import axios from "axios";

class RoamingHybridInvoiceService {
    constructor() {
        this.baseUrl = '/roaming-reference'
    }

    registerHybridInvoice(params) {
        return axios.post(`${this.baseUrl}/roaming/hybrid-invoice/draft/register`, params)
    }

    getDocumentGeneratorHashcode(params) {
        return axios.post(`${this.baseUrl}/roaming/hybrid-invoice/document-generator/hashcode`, {
            params: params
        })
    }
}

const roamingHybridInvoiceService = new RoamingHybridInvoiceService();
export default roamingHybridInvoiceService;